import styled from '@emotion/styled'

interface CommentTextProps {
  isClamped: boolean
}

const MAX_COLLAPSED_LINES = 4

export const CommentText = styled.p<CommentTextProps>`
  display: -webkit-box;
  overflow: hidden;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: ${({ isClamped }) => (isClamped ? MAX_COLLAPSED_LINES : 'unset')};
`
